module.exports = __webpack_public_path__ + "img/box-clischeduleH.a2fa33b8.png";